// tslint:disable-next-line:no-var-requires
const sprintf = require("sprintf-js").sprintf;

// tslint:disable-next-line:no-var-requires
const colors = require("colors-mini");

const levelColors = {
  TRACE: (s: string) => colors.black(s),
  DEBUG: (s: string) => colors.green(s),
  INFO: (s: string) => colors.grey(s),
  WARN: (s: string) => colors.magenta(s),
  ERROR: (s: string) => colors.red(s),
};

export const LEVEL_INT_ERROR = 0;
export const LEVEL_INT_WARN = 1;
export const LEVEL_INT_INFO = 2;
export const LEVEL_INT_DEBUG = 3;
export const LEVEL_INT_TRACE = 4;

export const LevelsString2Int = {
  ERROR: LEVEL_INT_ERROR,
  WARN: LEVEL_INT_WARN,
  INFO: LEVEL_INT_INFO,
  DEBUG: LEVEL_INT_DEBUG,
  TRACE: LEVEL_INT_TRACE,
};

interface LoggerAppender {
  log(name: string, level: number, message: string): void;
}

// tslint:disable-next-line:max-classes-per-file
/** @deprecated */
class Logger {
  private static appenders: LoggerAppender[] = [];

  public static getLogger(name: string) {
    let res = Logger.loggersByName.get(name);
    if (!res) {
      res = new Logger(name);
      Logger.loggersByName.set(name, res);
    }
    return res;
  }

  public static addAppender(appender: LoggerAppender) {
    Logger.appenders.push(appender);
  }

  public static removeAppender(appender: LoggerAppender) {
    Logger.appenders = Logger.appenders.filter(app => app != appender);
  }

  public static enable(
    level: "trace" | "info" | "warn" | "error" | "debug" | "*" = "*",
    name: string = "*",
  ) {
    if (name === "*") {
      // reenable all console appenders
      Logger.defaultSilent = false;
      if (level === "*") {
        Logger.defaultLogLevel = LEVEL_INT_TRACE;
      } else {
        Logger.defaultLogLevel = (LevelsString2Int as Record<string,number>)[level.toUpperCase()];
      }
      for (const e of Logger.loggersByName) {
        const logger = e[1];
        logger.silent = false;
        if (level === "*") {
          logger.level = LEVEL_INT_TRACE;
        } else {
          logger.level = (LevelsString2Int as Record<string,number>)[level.toUpperCase()];
        }
      }
    } else if (Logger.loggersByName.has(name)) {
      // find correspponding logger
      const logger = Logger.loggersByName.get(name)!;
      logger.silent = false;
      if (level === "*") {
        logger.level = LEVEL_INT_TRACE;
      } else {
        logger.level = (LevelsString2Int as Record<string,number>)[level.toUpperCase()];
      }
    }
  }

  public static disable(
    level: "trace" | "info" | "warn" | "error" | "debug" | "*" = "*",
    name: string = "*",
  ) {
    if (name === "*") {
      Logger.defaultSilent = true;

      // disable all loggers
      for (const entry of Logger.loggersByName) {
        if (level === "*") {
          entry[1].silent = true;
        } else {
          entry[1].level = (LevelsString2Int as Record<string,number>)[level];
        }
      }
    } else if (Logger.loggersByName.has(name)) {
      // find correspponding logger
      const logger = Logger.loggersByName.get(name)!;
      if (level === "*") {
        logger.silent = true;
      } else {
        logger.level = (LevelsString2Int as Record<string,number>)[level.toUpperCase()];
      }
    }
  }

  private static loggersByName: Map<string, Logger> = new Map();
  private static defaultSilent = true;
  private static defaultLogLevel = LEVEL_INT_WARN;

  private name: string;
  private silent = Logger.defaultSilent;
  private level = Logger.defaultLogLevel;

  constructor(name: string) {
    this.name = name;
  }
  public info(...args: any) {
    this.log("info", args);
  }

  public debug(...args: any) {
    this.log("debug", args);
  }

  public warn(...args: any) {
    this.log("warn", args);
  }

  public error(...args: any) {
    this.log("error", args);
  }

  private log(level: string, args: any[]) {
    const levelUp = level.toUpperCase();

    const formattedDate = new Date()
      .toTimeString()
      .replace(/.*(\d{2}:\d{2}:\d{2}).*/, "$1");

    const prefixNotColored = `[${formattedDate}] ${levelUp} [${this.name}]`;
    const levelInt = (LevelsString2Int as Record<string,number>)[levelUp];
    const message: string = args[0];
    const newArgs = new Array(args.length);
    for (let i = 1; i < args.length; i++) {
      newArgs[i] = args[i];
    }

    if (!this.silent && levelInt <= this.level) {
      const prefixColored = (levelColors as Record<string,(s:string)=>void>)[levelUp](
        `[${formattedDate}] ${levelUp} [${this.name}]`,
      );
      newArgs[0] = `${prefixColored} ${message}`;

      (console as any)[level].apply(console, newArgs);
    }

    try {
      newArgs[0] = `${prefixNotColored} ${message.replace(/%o/g, "%j")}`;
      const formattedMessage = sprintf.apply(undefined, newArgs);
      for (const appender of Logger.appenders) {
        try {
          appender.log(this.name, levelInt, formattedMessage);
        } catch (e) {
          console.error("Got error ", e);
        }
      }
    } catch (e) {
      console.error("Got error ", e);
    }
  }
}

export default Logger;
export { Logger };
